/**
 * Created by osirvent on 02/02/2016.
 */

var FilterDefinition = function() {

}